import { createFileRoute } from "@tanstack/react-router";

import { StatsSummary } from "@/features/opportunities/StatsSummary";
import { DEFAULT_RANGE, rangeSearch } from "@/features/opportunities/search";

export const Route = createFileRoute("/stats/")({ component: StatsOverview, validateSearch: rangeSearch });

function StatsOverview() {
    const { days = DEFAULT_RANGE } = Route.useSearch();
    const navigate = Route.useNavigate();

    return <StatsSummary days={days} onDays={(range) => navigate({ search: { days: range } })} />;
}
